// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__24-W6","content":"ManualTimeModal_content__3XGEc"};